import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Skeleton } from "../interfaces/CommonInterfaces";
import { OverviewResourceTypesProps } from "./interfaces/interface";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer
} from "recharts";

export default function OverviewResourceTypes({
  fromdetails = false,
  resourceType,
  loading
}: OverviewResourceTypesProps) {

  const totalResourceTypeValue =
    resourceType && resourceType.length > 0
      ? resourceType.reduce((sum, item) => sum + item.value, 0)
      : 0;

  const formattedData =
    resourceType && resourceType.length > 0
      ? (() => {
        return resourceType.map((item, index) => ({
          name: item.name,
          value: ((item.value / totalResourceTypeValue) * 100).toFixed(2),
          color: item.color
        }));
      })()
      : [];

  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle>Resource type</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {loading ? (
          <>
            {/* Chart Skeleton */}
            <div className="flex items-center justify-center h-40">
              <Skeleton className="w-32 h-32 rounded-full" />
            </div>

            {/* Legend Skeleton */}
            <div className="grid grid-cols-2 gap-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="flex items-center justify-between text-xs">
                  <div className="flex items-center gap-2">
                    <Skeleton className="w-3 h-3 rounded-full" />
                    <Skeleton className="w-16 h-3" />
                  </div>
                  <Skeleton className="w-6 h-3" />
                </div>
              ))}
            </div>
          </>
        ) : resourceType && resourceType.length > 0 ? (
          <>
            {/* Actual Chart */}
            <div className="h-40">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={resourceType as any}
                    cx="50%"
                    cy="50%"
                    innerRadius={40}
                    outerRadius={80}
                    paddingAngle={2}
                    dataKey="value"
                    isAnimationActive={false}
                  >
                    {resourceType?.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip
                    formatter={(value) => {
                      const numericValue = Number(value);
                      const percentage =
                        totalResourceTypeValue > 0
                          ? ((numericValue / totalResourceTypeValue) * 100).toFixed(2)
                          : "0.00";
                      return [`${percentage}%`, ""];
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>

            {/* Actual Legend */}
            <div className="grid grid-cols-2 gap-2">
              {formattedData?.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between text-xs"
                >
                  <div className="flex items-center gap-2">
                    <div
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: item.color }}
                    ></div>
                    <span className="text-muted-foreground">{item.name}</span>
                  </div>
                  <span className="font-medium">{item.value}%</span>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="flex items-center justify-center h-40 text-sm text-muted-foreground">
            No data found.
          </div>
        )}
      </CardContent>
    </Card>
  );
}
